import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import ArrowLeft from "./ArrowLeft.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import Box from '@mui/material/Box';
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';



let elavideo = [];


function ihs(f)
{
	return (window.innerHeight * f) + "px";
}


function JalostusMob(p)
{
		elavideo = p.elavideo;
		let curWidth = "" + (window.innerWidth -  100) + "px";
		return(<div style={{color: "#000000", fontSize: "100%", textAlign: "center"}}>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.JALOSTUSTEKSTIT.ekaosiokuvamob} />
		</div>
		<div className="keskitettymob">
			<h1>{window.JALOSTUSTEKSTIT.ekaosio}</h1>
			<div key="gapihmomia" className="otsikkogap"></div>
			{window.JALOSTUSTEKSTIT.ekaosioekar}
			<div key="gapihmomib" className="paragap"></div>
			{window.JALOSTUSTEKSTIT.ekaosiotokar}
		</div>
		<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
		<div className="keskitettymob">
		<h3>{window.JALOSTUSTEKSTIT.tokaosioekar}</h3>
		</div>
		<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" width="40vh" height="100vh"/>
		<div style={{position: "relative", overflow: "hidden", width: "100%", height: ihs(0.5)}}>
			<div style={{position: "absolute",
					clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)"
}}>
				{elavideo}
			</div>
			<div style={{position: "absolute"}}>
				<img style={{width: "100%", height: "auto"}} src={window.JALOSTUSTEKSTIT.tokaosiokuva} />
			</div>
		</div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div key="gapihmomid" className="osiogap"></div>
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}} >
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettymob">
				{window.JALOSTUSTEKSTIT.tokaosiotokar}
				</div>
				<div className="keskitettymob">
				<h3>
				{window.JALOSTUSTEKSTIT.tokaosiokolmasr}
				</h3>
				</div>
			</div>
		</div>
		<div key="gapihmomik" className="osiogap"></div>
		<div className="keskitettymob">
		{window.JALOSTUSTEKSTIT.neljasosioekar}
		</div>
		<div key="gapihmomil" className="osiogap"></div>
		<div className="keskitettymob" style={{fontFamily: "montsB"}}>
			{window.JALOSTUSTEKSTIT.neljasosiotokar}
		</div>
		<div className="seuraavasivumob">
			<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
				<Link to="../automaatio" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToAutomaatioMob} >
					<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>AUTOMAATIO</span>
				</Link>
			</div>
			<div style={{transform: "scale(0.75)"}}>
				<Link to="../automaatio" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToAutomaatioMob} >
					<ArrowRight  key="nextpage" stroke="#000000"/>
				</Link>
			</div>
		</div>
				<div key="gapihmomidsiloppu" className="osiogap"></div>
		<div key="gapihmomidsiloppua" className="osiogap"></div>

	</div>);
}

function moveToAutomaatioMob()
{
	window.SETAUTOMAATIO();
	window.drawAutomaatio();
}
/*
		<div style={{position: "absolute", left: "0px"}}>
			<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" scale="0.1" />
		</div>
		<div style={{position:"absolute", left:"0px"}}>
			<BlobRight fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" scale="0.1" />
		</div>
*/


export default JalostusMob;
